import type { ColDef } from '@ag-grid-community/core';
import type {
  AggregateReportConfig,
  ReportData,
} from '../report-viewer/report-viewer.model';

/**
 * Column Definitions for Model/AUE by OU Report
 * Updated hierarchy: AUE Date → Model → OU
 */
export const MODEL_AUE_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Auto-Update Expiration (AUE) / Model / OU',
    field: 'groupHierarchy',
  },
  {
    headerName: 'Device Count',
    field: 'deviceCount',
    flex: 1,
    aggFunc: 'sum',
  },
];

/**
 * Configuration for Model/AUE by OU aggregate report
 * Updated hierarchy: AUE Date → Model → OU
 */
export function createModelAueByOuReportConfig(data: unknown[]): ReportData {
  const aggregateConfig: AggregateReportConfig = {
    columns: MODEL_AUE_COLUMN_DEFS,
    groupFields: ['aueFormatted', 'model', 'orgUnitPath'],
    aggregationField: 'deviceCount',
    autoGroupColumnName: 'Auto-Update Expiration (AUE) / Model / OU',
    data,
  };

  return {
    type: 'model-aue',
    data,
    aggregateConfig,
  };
}
